import { attr, belongsTo } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

class CompanyLatestReportStat extends ShModel {
  @attr('date') currentReportCreatedAt;
  @attr('date') previousReportCreatedAt;
  @attr('number') spendYtdInCents;
  @attr('number') projectsCountLatestFullMonth;
  @attr('number') projectsSpendLatestFullMonthInCents;
  @attr('number') projectsCountPreviousFullMonth;
  @attr('number') projectsSpendPreviousFullMonthInCents;

  @belongsTo('company', { async: false }) company;
}

export default CompanyLatestReportStat;
